// Memorial entry for Itzhak Elgarat
import itzhakElgaratPortrait from '../../../images/itzhak-elgarat.jpg';

export const itzhakElgaratMemorial = {
  id: 31,
  name: 'Itzhak Elgarat',
  images: {
    portrait: itzhakElgaratPortrait
  },
  info: `
"Danny, this is the end, Danny this is the end." - Itzhak's final words to his brother

# Itzhak Elgarat

![Itzhak Elgarat](${itzhakElgaratPortrait})
*Itzhak "Itzik" Elgarat, 68, Danish-Israeli, the man who could fix everything*

## A Life Between Two Worlds

Itzhak "Itzik" Elgarat was born in Bat Yam and followed his older siblings to Kibbutz Nir Oz after his IDF service. There he met Dorota, a Danish volunteer. They fell in love, married, and moved to Denmark for 12 years, raising two children - Ronni and Max. After their divorce, Itzik returned to Nir Oz, though he traveled regularly to see his children and they visited the kibbutz often.

For many years, Itzik served as the kibbutz's maintenance supervisor and handyman. "He could fix everything and anything," the community remembered. He was responsible for all plumbing, gas lines, steam systems, and infrastructure.

## The Soul of the Kibbutz

But Itzik was far more than a handyman. The kibbutz described him as "an integral part of the social landscape. He always knew how to connect generations, to welcome people with all his heart, to fill evenings with laughter, backgammon and soccer games."

He was a passionate Maccabi Tel Aviv fan and supporter of the Danish national team. He competed in the kibbutz's annual Shavuot soccer tournament. He loved the music of Arik Einstein and Ehud Banai. He was a world traveler who had visited Norway, Thailand, Italy, Georgia, Bulgaria, Portugal, Romania, Morocco, and more.

His nephew called him "our man of the world" and "a football genius."

## October 7, 2023

When terrorists tried to enter his home, Itzik held the safe room door closed. They shot through the door, wounding his hand. At 11:27 a.m., while wounded and under attack, he called his brother Danny.

Danny instructed him how to make a tourniquet. Then he heard shouting in Arabic, and Itzik's final words: "Danny, this is the end, Danny this is the end."

Phone tracking showed Itzik's phone crossed into Gaza at noon. He was taken to Shifa Hospital for treatment of his wound.

## Tortured and Killed

Released hostages confirmed seeing Itzik alive in Gaza. But Hamas made a fatal error: they saw an eagle-shaped tattoo on his hand and believed he was an IDF pilot. He was taken for interrogation.

According to testimony from fellow hostage Edan Alexander and an autopsy conducted after his body was returned, Itzik was tortured to death. He suffered multiple broken ribs, broken toes, and a broken nose.

His brother Danny stated plainly: "Itzik didn't die from a heart attack. Itzik was murdered with extreme cruelty."

He died on March 15, 2024 - five months after his capture.

## Two Countries Mourn

On February 27, 2025 - 510 days after capture - Itzik's body was returned to Israel. Thousands attended his funeral at Nir Oz on March 3, 2025. A Maccabi Tel Aviv jersey was placed on his grave.

Denmark honored their citizen with remarkable dignity. The Queen of Denmark sent a special envoy with flowers. Prime Minister Mette Frederiksen wrote a personal handwritten letter. The Danish parliament observed a moment of silence. A town square was named for him.

His brother Danny noted bitterly that no Israeli coalition members attended or called - only one MK, Yaakov Asher, came to comfort the family.

## Remembering Itzik

His sister Rachel spoke at the funeral: "You, Itzik, fought them with a fierce heart. They took you alive. I believed so much that you would return alive... They tortured you, they starved you, you left in great agony."

Danny added: "You're going home to Nir Oz. I promised to bring you back dead or alive, and now you're coming home."

The peaceful handyman who loved soccer and backgammon, killed by captors who mistook a decorative tattoo for military insignia - a cruel irony that captures the senselessness of his death.

*His smile symbolized optimism, and his huge heart was always open to anyone who needed it. May his memory be a blessing.*

[Read more about Itzhak Elgarat](https://www.timesofisrael.com/hamas-tortured-hostage-itzik-elgarat-to-death-thinking-he-was-a-pilot-says-brother/)
`
};
